import type { IconData } from '@stacksjs/iconify-core'

export const penAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23.686 456.521a24.84 24.84 0 0 0 6 25.708l.087.087a24.84 24.84 0 0 0 17.612 7.342a25.2 25.2 0 0 0 8.1-1.344a646.3 646.3 0 0 0 248.04-154.207l166.456-166.461A88.832 88.832 0 1 0 344.354 42.019l-9.534 9.534l-20.791-20.791a50.4 50.4 0 0 0-71.274 0L108.687 164.83l22.626 22.627L265.382 53.389a18.4 18.4 0 0 1 26.019 0l20.792 20.791l-134.3 134.3A646.3 646.3 0 0 0 23.686 456.521m343.3-391.875a56.832 56.832 0 1 1 80.373 80.373l-89.493 89.493l-80.372-80.373Zm-112.124 112.12l80.372 80.372l-54.342 54.342A614.4 614.4 0 0 1 58.779 453.221A614.4 614.4 0 0 1 200.52 231.108Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default penAlt
